// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__zmYZz","imageUploader":"EGiftCard_imageUploader__gYIn9"};